// extracted by mini-css-extract-plugin
export default {"uploadVideo":"styles_uploadVideo__hF60j","buttonTextStyle":"styles_buttonTextStyle__SLgU0","skeleton":"styles_skeleton__KnEvV"};